import { CLEAR_BOARD_SELECTION } from './actionTypes';

export default (objectType) => ({
  type: CLEAR_BOARD_SELECTION,
  payload: {
    objectType
  }
});